import { useAuthMutation } from "@bn/api";
import { assignContraAccount } from "@api";

export const useAssignContraAccount = () =>
  useAuthMutation(assignContraAccount);
